'use strict';

(function () {
  'use strict';

  angular.module('msTracker').controller('RecordMultipleTrackerValuesModalCtrl', RecordMultipleTrackerValuesModalCtrl);

  RecordMultipleTrackerValuesModalCtrl.$inject = ['$log', 'trackers', 'messageId', 'defaultMessage', 'close', 'moodTrackerSvc'];

  /* @ngInject */
  function RecordMultipleTrackerValuesModalCtrl($log, trackers, messageId, defaultMessage, close, moodTrackerSvc) {
    var vm = this;
    vm.title = 'RecordMultipleTrackerValuesModalCtrl';

    activate();

    vm.doneWithMoodTrack = function () {
      return recordTrackerEntry(formatTrackerEntriesForRequest(vm.trackerValues));
    };

    // 300ms pause to let ngAnimate hide the modal.
    vm.closeModal = function () {
      return close(false, 300);
    };

    ////////////////

    function activate() {
      $log.debug(vm.title + ' control activate');

      vm.trackerInputs = trackers;
      vm.messageId = messageId;
      vm.trackerNote = defaultMessage;
      vm.trackerValues = [];

      if (trackers[0].datetime) {
        vm.entryDate = trackers[0].datetime.format('dddd, MMMM Do');
      } else {
        vm.entryDate = moment().format('dddd, MMMM Do');
      }
    }

    function formatTrackerEntriesForRequest(trackerEntriesArray) {
      var entries = [];
      trackerEntriesArray.forEach(function (part, index, arr) {
        entries.push({
          id: arr[index].tracker.id,
          entryId: arr[index].tracker.entryId,
          moodValue: arr[index].value
        });
      });
      return entries;
    }

    function recordTrackerEntry(entriesData) {
      // http request happens here. When it is done (and it succeeds), close the modal.
      moodTrackerSvc.saveMoods(entriesData, vm.messageId, vm.trackerNote).then(function (result) {
        // 300ms pause to let ngAnimate hide the modal.
        // pass the saved model back to parent for updating
        close(result, 300);
      });
    }
  }
})();